import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Inbox, Briefcase, Tag, LogOut, Loader2, ExternalLink } from "lucide-react";
import { adminVerify, clearToken, getToken } from "../api";
import Logo from "../components/Logo";
import MessagesPanel from "../components/admin/MessagesPanel";
import JobsPanel from "../components/admin/JobsPanel";
import CategoriesPanel from "../components/admin/CategoriesPanel";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("messages");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!getToken()) {
      navigate("/admin/login");
      return;
    }
    adminVerify()
      .then(() => setChecking(false))
      .catch(() => {
        clearToken();
        navigate("/admin/login");
      });
  }, [navigate]);

  const logout = () => {
    clearToken();
    navigate("/admin/login");
  };

  if (checking) {
    return (
      <div className="App min-h-screen flex items-center justify-center text-white/50">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  const tabs = [
    { id: "messages", label: "Wiadomości", icon: Inbox },
    { id: "jobs", label: "Ogłoszenia", icon: Briefcase },
    { id: "categories", label: "Kategorie", icon: Tag },
  ];

  return (
    <div className="App min-h-screen">
      {/* Top bar */}
      <header className="sticky top-0 z-40 border-b border-white/10 bg-black/70 backdrop-blur-xl">
        <div className="container-px mx-auto max-w-6xl flex items-center justify-between py-4">
          <div className="flex items-center gap-4">
            <Logo />
            <span className="hidden sm:inline rounded-full border border-white/15 px-3 py-1 text-xs uppercase tracking-widest text-white/55">
              Panel Admina
            </span>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => window.open("/", "_blank")}
              className="glass-btn px-4 py-2 text-sm font-medium"
            >
              <ExternalLink className="h-4 w-4" /> <span className="hidden sm:inline">Zobacz stronę</span>
            </button>
            <button onClick={logout} className="glass-btn px-4 py-2 text-sm font-medium">
              <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Wyloguj</span>
            </button>
          </div>
        </div>
      </header>

      <main className="container-px mx-auto max-w-6xl py-10">
        {/* Tabs */}
        <div className="mb-8 inline-flex rounded-full border border-white/15 bg-white/5 p-1.5">
          {tabs.map((tb) => {
            const Icon = tb.icon;
            return (
              <button
                key={tb.id}
                onClick={() => setTab(tb.id)}
                className={`flex items-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold transition-all ${
                  tab === tb.id ? "bg-white text-black" : "text-white/65 hover:text-white"
                }`}
              >
                <Icon className="h-4 w-4" />
                {tb.label}
              </button>
            );
          })}
        </div>

        {tab === "messages" && <MessagesPanel />}
        {tab === "jobs" && <JobsPanel />}
        {tab === "categories" && <CategoriesPanel />}
      </main>
    </div>
  );
};

export default AdminDashboard;
